export const GetBrand = () => {
	var isCRM = _.config.Item("isCRM");
	if (isCRM != 1) {
		if (_.config.Item("whitelabelBrand")) {
			return _.config.Item("whitelabelBrand");
		} else {
			return "PC Matic";
		}
	} else {
		return "PC Matic";
	}
};
